<i
  *ngIf="source === 'ai'"
  class="fas fa-wand-magic-sparkles source-glyph source-glyph--ai"
  role="img"
  [ngbTooltip]="'AI_PARSER_SOURCE_AI_TOOLTIP' | translate"
  [attr.aria-label]="'AI_PARSER_SOURCE_AI_TOOLTIP' | translate"
></i>
<i
  *ngIf="source === 'config'"
  class="fas fa-gear source-glyph"
  role="img"
  [ngbTooltip]="'AI_PARSER_SOURCE_CONFIG_TOOLTIP' | translate: { name: configName }"
  [attr.aria-label]="'AI_PARSER_SOURCE_CONFIG_TOOLTIP' | translate: { name: configName }"
></i>
<i
  *ngIf="source === 'manual'"
  class="fas fa-pen source-glyph"
  role="img"
  [ngbTooltip]="'AI_PARSER_SOURCE_MANUAL_TOOLTIP' | translate"
  [attr.aria-label]="'AI_PARSER_SOURCE_MANUAL_TOOLTIP' | translate"
></i>
